/* eslint-disable yoda */
import React, { useRef, useState } from 'react'
import cx from 'clsx'
import Scrollspy from 'react-scrollspy'
import { Link } from 'gatsby'
import { useSpring, animated } from 'react-spring'

// Material-UI
import { makeStyles } from '@material-ui/core/styles'
// Style
import { useStyles } from '~components/Timeline/Timeline.style'
import '~components/Timeline/timeline.css'
// Utils
import { lpad } from '~utils/'
// Hooks
import { useScrollPosition } from '@n8tb1t/use-scroll-position'

const useStylesTimeline = makeStyles(() => ({
  wrapper: {
    float: 'right',
    opacity: '0.95',
    position: 'fixed',
    right: 0,
    top: '25%',
    width: '100%',
    zIndex: '999',
  },
}))

/**
 *
 * @note
 * Timeline will not dispaly when Filtered
 * This only deals with the 250 (+ Feature Cards)
 */

/**
 * Timeline Dials: Range or Specific
 */

const ItemTimeline = ({ location }) => {
  const classes = useStylesTimeline()
  return (
    <div className={cx(classes.wrapper)}>
      <ItemTimelineComponent location={location} />
    </div>
  )
}

const ItemTimelineComponent = ({ location }) => {
  const classes = useStyles()
  const timelineRef = useRef()

  const [isScrolling, setIsScrolling] = useState(false)
  let timer = null

  // eslint-disable-next-line no-unused-vars
  const handleScrollPositionCallback = ({ prevPos, currPos }) => {
    if (timer) {
      clearTimeout(timer)
    }
    if (0 >= currPos.y) {
      setIsScrolling(false)
    } else {
      timer = setTimeout(() => {
        timer = null
        setIsScrolling(false)
      }, 1500)

      if (!isScrolling) {
        setIsScrolling(true)
        if (timer) {
          clearTimeout(timer)
        }
      }
    }
  }

  /**
   * @note
   * useScrollPosition(effect, deps, element, useWindow, wait)
   */
  useScrollPosition(
    handleScrollPositionCallback,
    [isScrolling],
    timelineRef,
    true,
    100
  )

  const { marginRight } = useSpring({
    config: {
      duration: 150,
      friction: 60,
      mass: 1,
      tension: 280,
    },
    marginRight: `${isScrolling && window.innerWidth < 600 ? -80 : 0}px`,
  })

  const timelineDials = ['250', '200', '150', '100', '50', '1']
  const scrollspyItems = [
    'card-250',
    'card-200',
    'card-150',
    'card-100',
    'card-50',
    'card-1',
  ]

  return (
    <animated.section
      className={cx(classes.timeline)}
      ref={timelineRef}
      style={{ marginRight }}
    >
      <Scrollspy
        className={cx(classes.timelineList)}
        items={scrollspyItems}
        currentClassName=""
        onUpdate={(el) => {
          if (el) {
            const currentCardMilestone = el.getAttribute('id')
            /* Add this information so we can update the timeline with CSS */
            document.body.setAttribute(
              'data-current-page',
              currentCardMilestone
            )
          }
        }}
      >
        {timelineDials &&
          timelineDials.map((timelineDial, timelineIndex) => {
            const isActive = true
            const isDisabled = false

            return (
              <li
                id={`linkto-card-${timelineDial}`}
                className={cx(classes.timelineListItem)}
                key={`timeline-${timelineIndex}`}
              >
                <Link
                  aria-controls={`card-${timelineDial}`}
                  className={cx(classes.timelineListButton)}
                  disabled={isDisabled}
                  to={`${location.pathname.replace(
                    '/fandoms-of-the-year/',
                    '/'
                  )}#card-${timelineDial}`}
                  onClick={() => {
                    document.body.setAttribute(
                      'data-current-page',
                      `card-${timelineDial}`
                    )
                  }}
                >
                  {isActive && !isDisabled && lpad(timelineDial)}
                </Link>
              </li>
            )
          })}
      </Scrollspy>
    </animated.section>
  )
}

export default ItemTimeline
